import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarEventos } from '../../actions/eventos';
import { editarBreadcrumb } from '../../actions/breadcrumb';
import { formatNumber } from '../../utils/generalFunctions';

import EliminarEvento from './EliminarEvento';

const Eventos = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { listado } = useSelector(state => state.eventos);
    const { usuario } = useSelector(state => state.auth);

    const [eventoEliminar, setEventoEliminar] = useState(null);

    useEffect(() => {
        dispatch(buscarEventos(false));
        dispatch(editarBreadcrumb([
            { nombre: 'Eventos', path: '/eventos', activo: true }
        ]));
    }, []);

    const handleEliminar = (evento) => {
        setEventoEliminar(evento);
    };

    const handleCerrarEliminar = () => {
        setEventoEliminar(null);
    };

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre || '-',
            grow: 2
        },
        {
            name: 'Método de pago',
            sortable: true,
            selector: row => row.metodo?.nombre || '-'
        },
        {
            name: 'Costo del evento',
            sortable: true,
            selector: row => row.total != null ? formatNumber(row.total, 2, '$', '') : '-'
        },
        {
            name: 'Fecha inicio',
            sortable: true,
            selector: row => row.fecha_inicio
                ? new Date(row.fecha_inicio).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
                : '-'
        },
        {
            name: 'Fecha fin',
            sortable: true,
            selector: row => row.fecha_fin
                ? new Date(row.fecha_fin).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
                : '-'
        },
        {
            name: '¿Las ventas se cobran?',
            sortable: true,
            selector: row => row.cobrado === true ? 'Sí' : 'No'
        },
        {
            name: '',
            cell: row => (
                <div>
                    {usuario?.permisos?.eventos?.ver && (
                        <Link className="btn btn-sm btn-info me-1" title="Ver detalles" to={`/eventos/detalles/${row._id}`}>
                            <i className="fas fa-eye"></i>
                        </Link>
                    )}
                    {usuario?.permisos?.eventos?.editar && (
                        <button
                            className="btn btn-sm btn-warning me-1"
                            title="Editar"
                            onClick={() => navigate(`/eventos/editar/${row._id}`)}
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    )}
                    {usuario?.permisos?.eventos?.eliminar && (
                        <button
                            className="btn btn-sm btn-danger"
                            title="Eliminar"
                            onClick={() => handleEliminar(row)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Eventos</h4>
                {usuario?.permisos?.eventos?.agregar && (
                    <button className="btn btn-primary" onClick={() => navigate('/eventos/nuevo')}>
                        <i className="fas fa-plus me-1"></i> Nuevo evento
                    </button>
                )}
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay eventos registrados"
                />
            </div>

            <EliminarEvento
                evento={eventoEliminar}
                handleCerrar={handleCerrarEliminar}
            />
        </div>
    );
};

export default Eventos;
